import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Resets scroll position to (0, 0) on every route change.
 * Skips reset when navigating to an in-page anchor (URL contains a hash).
 * Must be rendered inside <BrowserRouter> and above <Routes>.
 */
export default function ScrollToTop() {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        if (hash) return; // let the browser handle #anchor navigation
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }, [pathname, hash]);

    return null;
}
